import styled from "styled-components";

/* Docked on the right with no backdrop (Matthew, 2026-11-01: "I need to be
   able to see the document while I'm reviewing these"): the open document
   stays visible and scrollable to the left of the panel. */
export const ReviewDrawer = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 460px;
  max-width: 92vw;
  background: #fff;
  box-shadow: -8px 0 32px rgba(33, 41, 52, 0.18);
  border-left: 1px solid #dde2e9;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 20px 20px 16px;
  font-family: "Manrope", sans-serif;
  z-index: 1300;
`;

export const DrawerTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  color: #1b2028;
  margin: 0 36px 12px 0;
`;

export const PageLink = styled.button`
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #0c53bb;
  background: none;
  border: none;
  padding: 0;
  margin-top: 4px;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: #084080;
  }
`;

export const ReviewBody = styled.div`
  overflow-y: auto;
  flex: 1 1 auto;
  margin: 0 -8px 16px;
  padding: 0 8px;
`;

export const FormLine = styled.div`
  font-size: 13px;
  line-height: 20px;
  color: #5a6c87;
  margin-bottom: 16px;
`;

export const Headline = styled.div`
  font-weight: 600;
  font-size: 15px;
  line-height: 22px;
  color: ${(props) => (props.$tone === "stop" ? "#b42318" : props.$tone === "warn" ? "#b54708" : "#067647")};
  margin-bottom: 12px;
`;

export const Group = styled.div`
  margin-bottom: 18px;
`;

export const GroupTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #5a6c87;
  margin-bottom: 8px;
`;

export const Item = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 10px 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  font-size: 13px;
  line-height: 20px;
  color: #1b2028;
  background: ${(props) => (props.$tone === "stop" ? "#fef3f2" : props.$tone === "warn" ? "#fffaeb" : props.$tone === "pass" ? "#f6fef9" : "#f3f4f7")};
  border: 1px solid ${(props) => (props.$tone === "stop" ? "#fecdca" : props.$tone === "warn" ? "#fedf89" : props.$tone === "pass" ? "#abefc6" : "#dde2e9")};
`;

export const Mark = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  background: ${(props) => (props.$tone === "stop" ? "#d92d20" : props.$tone === "warn" ? "#f79009" : props.$tone === "pass" ? "#17b26a" : "#98a2b3")};
`;

export const ItemBody = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const Snippet = styled.img`
  display: block;
  margin-top: 8px;
  max-width: 100%;
  max-height: 180px;
  border: 1px solid #dde2e9;
  border-radius: 6px;
  background: #fff;
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
`;

export const Small = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: #5a6c87;
`;

export const PassList = styled.ul`
  margin: 0;
  padding: 0 0 0 18px;
  font-size: 12px;
  line-height: 18px;
  color: #344054;
`;

export const OverrideBox = styled.div`
  border: 1px solid #fecdca;
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
`;

export const OverrideLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #1b2028;
  cursor: pointer;
  input {
    width: 16px;
    height: 16px;
  }
`;

export const ReasonInput = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  margin-top: 10px;
  min-height: 56px;
  resize: vertical;
  border: 1px solid #dde2e9;
  border-radius: 6px;
  padding: 8px 10px;
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  line-height: 20px;
  color: #1b2028;
  &:focus {
    outline: none;
    border-color: #0c53bb;
  }
`;

export const Notice = styled.div`
  font-size: 13px;
  line-height: 20px;
  color: #b42318;
  margin-bottom: 12px;
`;

export const SubmitButton = styled.button`
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 100%;
  border-radius: 6px;
  border: none;
  background: #0c53bb;
  color: #fff;
  height: 32px;
  padding: 10px 14px;
  min-width: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    background: ${(props) => (props.disabled ? "#0c53bb" : "#084080")};
  }
`;
